import React from 'react';
import '../styles/Footer.css';

const Footer = () => {
    return (
        <div className="footer">
            <p>© 2026 Alexia Cerdas Aguilar</p>
        </div>
    );
}

export default Footer;